import axios from "axios";

/** Chamadas públicas ao BFF (sem token), ex.: continuar cadastro pré-preenchido pela franquia. */
const publicApi = () => {
  return axios.create({
    baseURL: process.env.VUE_APP_API_BASE_URL,
    withCredentials: false,
  });
};

export default publicApi;
